/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  NestedErrorMessage,
  initSlicePageable,
  SlicePaginationResponse,
} from "@advapacs/common";
import {
  INotification,
  NumberOfNotification,
} from "../../../types/notification";
const initialState = {
  loading: false,
  errorMessage: null as NestedErrorMessage | null,
  entities: [] as Array<INotification>,
  count: 0,
  pageable: initSlicePageable,
  fetching: false,
  nextPage: 0,
  fetchCount: 0,
  intervalSeconds: 60,
};

const notificationSlice = createSlice({
  name: "notificationSlice",
  initialState,
  reducers: {
    addNotifications(
      state,
      action: PayloadAction<SlicePaginationResponse<INotification>>
    ) {
      const { content } = action.payload;
      state.entities.push(...content);
      state.pageable = action.payload.pageable;
    },
    fetchNotifications(state, action: PayloadAction<boolean>) {
      state.fetching = action.payload;
    },
    nextNotificationPage(state) {
      state.nextPage += 1;
    },
    clearNotification(state) {
      state.entities = [];
      state.pageable = initSlicePageable;
      state.nextPage = 0;
      state.fetching = false;
    },
    getNumberOfNotifications(state) {
      state.fetchCount += 1;
    },
    getSuccessNumberOfNotifications(
      state,
      action: PayloadAction<NumberOfNotification>
    ) {
      state.fetchCount -= 1;
      state.count = action.payload.count;
    },
    getFailNumberOfNotifications(state) {
      state.fetchCount -= 1;
      state.count = 0;
    },
    clearVariableCountNotification(state) {
      state.fetchCount = 0;
      state.count = 0;
    },
    updateStatusNotification(
      state,
      action: PayloadAction<Array<INotification>>
    ) {
      state.entities = action.payload;
      state.count -= 1;
    },
    updateFailStatusNotification(state) {
      state.count += 1;
    },
    getSuccessDismissAllNotifications(state) {
      state.count = 0;
    },
  },
});

export const NotificationAction = notificationSlice.actions;
export default notificationSlice.reducer;
